import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";

@Component({
  selector: 'app-eft-check-example',
  templateUrl: './eft-check-example.component.html',
  styleUrls: ['./eft-check-example.component.scss']
})
export class EftCheckExampleComponent extends FieldType<FieldTypeConfig> {
}
